import { render, staticRenderFns } from "./register-item-ax.vue?vue&type=template&id=bb680676&scoped=true&"
import script from "./register-item-ax.vue?vue&type=script&lang=js&"
export * from "./register-item-ax.vue?vue&type=script&lang=js&"
import style0 from "./register-item-ax.vue?vue&type=style&index=0&id=bb680676&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb680676",
  null
  
)

export default component.exports